/* tslint:disable */
/* eslint-disable */
/**
 * Admin Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { RoleDTO } from './RoleDTO';
import {
    RoleDTOFromJSON,
    RoleDTOFromJSONTyped,
    RoleDTOToJSON,
    RoleDTOToJSONTyped,
} from './RoleDTO';
import type { PageMetadata } from './PageMetadata';
import {
    PageMetadataFromJSON,
    PageMetadataFromJSONTyped,
    PageMetadataToJSON,
    PageMetadataToJSONTyped,
} from './PageMetadata';

/**
 * 
 * @export
 * @interface PagedModelRoleDTO
 */
export interface PagedModelRoleDTO  {
    /**
     * 
     * @type {Array<RoleDTO>}
     * @memberof PagedModelRoleDTO
     */
    content?: Array<RoleDTO>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PagedModelRoleDTO
     */
    page?: PageMetadata;
}

/**
 * Check if a given object implements the PagedModelRoleDTO interface.
 */
export function instanceOfPagedModelRoleDTO(value: object): value is PagedModelRoleDTO {
    return true;
}

export function PagedModelRoleDTOFromJSON(json: any): PagedModelRoleDTO {
    return PagedModelRoleDTOFromJSONTyped(json, false);
}

export function PagedModelRoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedModelRoleDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(RoleDTOFromJSON)),
                  'page': json['page'] == null ? undefined : PageMetadataFromJSON(json['page']),
    };
}

export function PagedModelRoleDTOToJSON(json: any): PagedModelRoleDTO {
    return PagedModelRoleDTOToJSONTyped(json, false);
}

export function PagedModelRoleDTOToJSONTyped(value?: PagedModelRoleDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'] == null? value['content']: (value['content'] as Array<any>).map(RoleDTOToJSON),
        'page': PageMetadataToJSON(value['page']),
    };
}


